import { required, numeric, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'MAddress',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    line1: '',
    line2: '',
    city: '',
    state: '',
    postal_code: 0,
    country: 'Australia',
    states: ['NSW', 'ACT', 'QLD', 'VIC', 'SA', 'WA', 'NT', 'TAS'],
  }),
  methods: {
    handleValue([key, value]) {
      this[key] = value;
      this.$v[key].$touch();
      this.$emit('input', {
        line1: this.line1,
        line2: this.line2,
        city: this.city,
        state: this.state,
        postal_code: this.postal_code,
        country: this.country,
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        Object.entries(val).forEach(([key, value]) => {
          this[key] = value;
        });
      },
    },
  },
  validations: {
    line1: {
      required,
    },
    city: {
      required,
    },
    state: {
      required,
    },
    postal_code: {
      required,
      numeric,
      minLength: minLength(4),
    },
    country: {
      required,
    },
  },
};
